import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { AutoAwesome as SparkleIcon } from '@mui/icons-material';

interface QuestionCardProps {
  question: string;
  onClick?: () => void;
}

export const QuestionCard: React.FC<QuestionCardProps> = ({ question, onClick }) => {
  return (
    <Card
      sx={{
        cursor: 'pointer',
        backgroundColor: 'transparent',
        boxShadow: 'none',
      }}
      onClick={onClick}
    >
      <CardContent sx={{ py: 1, px: 1, '&:last-child': { pb: 1 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <SparkleIcon sx={{ color: 'primary.main', fontSize: 20 }} />
          <Typography
            variant="body2"
            sx={{
              fontSize: '0.95rem',
              fontWeight: '500',
              textAlign: 'left',
            }}
          >
            {question}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};
